import {Component} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {GlobalState} from '../../../global.state';
import { LoginService} from '../../../pages/login/login.service';

@Component({
  selector: 'ba-page-top',
  templateUrl: './baPageTop.html',
  styleUrls: ['./baPageTop.scss']
})
export class BaPageTop {

  public isScrolled:boolean = false;
  public isMenuCollapsed:boolean = false;
  public firstName:string = '';
  private isFullScreen = false;
  isAdmin;
  isEnterprise;
  siteUrl;
  // customSite;
  organization;
  orgName;
  isOrgLogo = 'false';
  orgLogo = null;
  constructor(private _state:GlobalState, private _auth: LoginService, private _route: ActivatedRoute, private _router : Router) {
    this.firstName = _auth.getFirstName();
    this.isAdmin = localStorage.getItem('isAdmin');
    this.isEnterprise = localStorage.getItem('isEnterpriseUser')
    this.organization = localStorage.getItem('organization').toLocaleUpperCase()
    let orgNameStr = localStorage.getItem('orgNameHeader')
    if(orgNameStr){
      this.orgName = localStorage.getItem('orgNameHeader')
    }
    else{
      this.orgName = this.organization
    }
    let icon = localStorage.getItem('orgIcon')

    if(icon && icon !== 'null'){
      this.orgLogo = localStorage.getItem('orgIcon') 
      $("#icon").attr("href",this.orgLogo);
      this.isOrgLogo = 'true'
    }
    else{
      this.isOrgLogo = 'false'
    }
    if(_router.url){
      let pageTitle = _route.snapshot.data['page_title']
      pageTitle = 'rEye - ' + this.orgName + '-' + pageTitle
      if(_route.snapshot.params && _route.snapshot.params.id){
        pageTitle =  pageTitle + '-' + _route.snapshot.params.id
      }
      if(_route.snapshot.params && _route.snapshot.params.name){
        pageTitle =  pageTitle + '-' + _route.snapshot.params.name
      }
      document.title = pageTitle
    } else{
      document.title = 'rEye - ' + this.orgName 
    }
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
    this._state.subscribe('menu.firstname', (name) => {
      this.firstName = name;
    });
  }
  public ngOnInit():void {

  
    
  }
  public toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
    return false;
  }

  public fullScreen() {
    var elem = document.body; // Make the body go full screen.
    this.requestFullScreen(elem);
  }

  requestFullScreen(element) {
    // Supports most browsers and their versions.
    
    
    if(!this.isFullScreen){
      var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
      if (requestMethod) { // Native full screen.
          requestMethod.call(element);
      } else if (typeof window['ActiveXObject'] !== "undefined") { // Older IE.
          // var wscript = new ActiveXObject("WScript.Shell");
          // if (wscript !== null) {
          //     wscript.SendKeys("{F11}");
          // }
      }
    }
    else{
      var requestMethod = document.exitFullscreen || document.webkitExitFullscreen || document['mozCancelFullScreen'] || document['msExitFullscreen'];
      if (requestMethod) { // Native full screen.
          requestMethod.call(document);
      } else if (typeof window['ActiveXObject'] !== "undefined") { // Older IE.
          // var wscript = new ActiveXObject("WScript.Shell");
          // if (wscript !== null) {
          //     wscript.SendKeys("{F11}");
          // }
      }
    }
    this.isFullScreen = !this.isFullScreen;
  }
  public logOut() {
    console.log('signout..');

    var username = localStorage.getItem('spaceageuser');
    localStorage.removeItem(username+'gpsCustomDateFilterOptions');
    localStorage.removeItem(username+'meterCustomDateFilterOptions');

    localStorage.removeItem('currentUser');
    localStorage.removeItem('firstName');
    localStorage.removeItem('username');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('organization');
    localStorage.removeItem('spaceageuser');
    localStorage.removeItem('spaceagepwd');
    localStorage.removeItem('hideMeteringDashboard');
    localStorage.removeItem('hideGPSDashboard');
    localStorage.removeItem('hideOneMapDashboard')
    localStorage.removeItem('hide3DVisualization');
    localStorage.removeItem('hideDiagnostics')    
    localStorage.removeItem('orgMetaData')    
    localStorage.removeItem('PAGES_MENU');

    localStorage.removeItem('dashboardsList');
    localStorage.removeItem('spaceagemaptype');

    setTimeout(function(){
      localStorage.removeItem('currentUser');
      localStorage.removeItem('firstName');
      localStorage.removeItem('username');
      localStorage.removeItem('isAdmin');
      localStorage.removeItem('isEnterpriseUser')
      localStorage.removeItem('organization');
      localStorage.removeItem('orgMetaData');
      localStorage.removeItem('spaceageuser');
      localStorage.removeItem('spaceagepwd');
      localStorage.removeItem('hideMeteringDashboard');
      localStorage.removeItem('hideGPSDashboard');
      localStorage.removeItem('hideUserActivity');
      localStorage.removeItem('hideOneMapDashboard')
      localStorage.removeItem('hideUserManagement')
      localStorage.removeItem('hideTriggerSettings');
      localStorage.removeItem('hide3DVisualization');
      localStorage.removeItem('PAGES_MENU');
      localStorage.removeItem('hideDiagnostics')    
      localStorage.removeItem('dashboardsList');
      localStorage.removeItem('spaceagemaptype');
    }, 3000);
  }
  public scrolledChanged(isScrolled) {
    this.isScrolled = isScrolled;
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/components/baPageTop/baPageTop.component.ts